__turbopack_context__.v({
  "breadcrumbs": "Breadcrumbs-module__I9t41G__breadcrumbs",
});
